import { render } from "./UserDocuments.vue?vue&type=template&id=7d8959b5&scoped=true"
import script from "./UserDocuments.vue?vue&type=script&lang=js"
export * from "./UserDocuments.vue?vue&type=script&lang=js"

import "./UserDocuments.vue?vue&type=style&index=0&id=7d8959b5&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d8959b5"]])

export default __exports__